import { default as WJElement } from '../wje-element/element.js';
import Card from './card.element.js';

// export * from "./card.element.js";
export default Card;

WJElement.define('wje-card', Card);
